import cmp from 'semver-compare';

export function getRuleConfig(formJSVersion) {
  if (!formJSVersion) { return {}; }

  const rules = Object.entries(versionedRuleConfig);
  const filteredRules = rules.filter(([ _, config ]) =>
    (!config.from || cmp(config.from, formJSVersion) <= 0) &&
    (!config.before || cmp(config.before, formJSVersion) > 0)
  );

  return filteredRules.reduce((acc, [ rule, config ]) => {
    acc[rule] = config.severity;
    return acc;
  }, {});
}

const versionedRuleConfig = {
  'form-element-type': { severity: 'error' },
  'no-dynamic-data': { before: '0.8.0', severity: 'error' },
  'no-validation-type': { before: '0.10.0', severity: 'error' },
  'no-text-expression': { before: '0.10.0', severity: 'warn' },
  'no-conditional-field': { before: '0.10.0', severity: 'error' },
  'no-decimal-number': { before: '0.10.0', severity: 'error' },
  'no-prefix-suffix': { before: '0.10.0', severity: 'error' },
  'no-text-template': { before: '0.13.0', severity: 'warn' },
  'no-searchable-select': { before: '0.13.0', severity: 'error' },
  'no-row-layout': { before: '0.13.0', severity: 'warn' },
  'no-required-validation': { before: '0.14.0', severity: 'error' },
  'validate-feel': { from: '0.10.0', severity: 'error' },
  'no-readonly': { before: '1.0.0', severity: 'error' },
  'discourage-disabled-fields' : { from: '1.0.0', severity: 'warn' },
  'no-label-expression': { before: '1.0.0', severity: 'error' },
  'no-description-expression': { before: '1.0.0', severity: 'error' },
  'no-label-template': { before: '1.0.0', severity: 'error' },
  'no-description-template': { before: '1.0.0', severity: 'error' },
  'no-image-templates': { before: '1.0.0', severity: 'error' },
  'no-prefix-suffix-templates': { before: '1.0.0', severity: 'error' },
  'no-prefix-suffix-expressions': { before: '1.0.0', severity: 'error' },
  'no-validation-expressions': { before: '1.0.0', severity: 'error' },
  'no-values-expression': { before: '1.0.0', severity: 'error' },
  'no-nested-component-key': { before: '1.3.0', severity: 'error' },
  'no-empty-lists': { from: '1.5.0', severity: 'warn' },
  'no-version-tag': { before: '1.10.0', severity: 'error' },
  'no-vertical-alignment': { before: '1.5.0', severity: 'warn' },
  'no-security-attributes': { before: '1.7.0', severity: 'error' },
  'no-submit-button': { severity: 'info' }
};
